<div class="container-fluid p-0">
  <div class="container navbar-container">
    <div class="d-flex mx-0 justify-content-between">
      <div class="logo-container">
        <div class="rg-logo logo">
          <img src="assets/images/rg-logo.svg" alt="">
        </div>
        <span class="separator"></span>
        <div class="ubc-logo logo">
          <img src="assets/images/ubc-logo.svg" alt="">
        </div>
      </div>
      <div class="buttons-container">
        <button class="btn-primary register-btn">
          <span class="btn-label">Register Now</span>
          <i class="pi pi-arrow-right"></i>
        </button>
      </div>
    </div>
  </div>
</div>
